export const Roles = {
	USER: 'User',
	OFFICIAL: 'Official',
	ASSIGNOR: 'Referee Assignor',
	REFADMIN: 'Referee Administrator',
	CLUB_ADMINISTRATOR: 'Club Administrator',
	CLUB_SCHEDULER: 'Club Scheduler',
	EVERGREEN: 'Evergreen Sports',
	DEVELOPER: 'Developer'
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];

export const RoleGroups = {
	ANY_AUTH: [Roles.USER, Roles.OFFICIAL, Roles.ASSIGNOR, Roles.REFADMIN, Roles.CLUB_ADMINISTRATOR, Roles.CLUB_SCHEDULER, Roles.EVERGREEN, Roles.DEVELOPER],
	CLUB: [Roles.CLUB_ADMINISTRATOR, Roles.CLUB_SCHEDULER],
	ASSIGNORADMIN: [Roles.ASSIGNOR, Roles.REFADMIN],
	EMPLOYEE: [Roles.EVERGREEN, Roles.DEVELOPER],
	SUPPORT_ADMIN: [Roles.EVERGREEN, Roles.DEVELOPER]
} as const satisfies Record<string, readonly RoleName[]>;

export type RoleGroupName = keyof typeof RoleGroups;
